import React, { Component } from 'react'
import { connect } from 'react-redux'
import { NoContentBox } from 'components/basic'
import { notify } from 'helpers'
import http from 'API/http'
import FileSaver from 'file-saver'

class BillingExport extends Component {
  async componentDidMount () {
    var id = this.props.match.params.id
    var [err, res] = await http.get('export/billing/csv/' + id)
    if (err) {
      notify.alert('', 'Export failed, try again', 'error')
      return window.location.hash = '/dashboard'
    }

    let blob = new window.Blob([res.data], { type: 'text/csv' })
    FileSaver.saveAs(blob, 'BillingExport' + id + '.csv')
    window.location.hash = '/dashboard'
  }
  render () {
    return (
      <div className='content-wrapper flexbox-absolute-center'>
        <NoContentBox icon='circle-o-notch fa-spin' text='Downloading...' />
      </div>
    )
  }
}
//eslint-disable-next-line
BillingExport = connect(state => state.siteReducer)(BillingExport)
export default BillingExport



// WEBPACK FOOTER //
// ./src/projects/access-gui/views/core/export/billing.js